import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import '../media/Img.js';
import { Icon } from '../media/Icon.js';
import React__default from 'react';
import styled from 'styled-components';
import { visuallyHiddenStyle } from '../../utils/visuallyHidden.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { Paragraph } from '../typography/Paragraph.js';
var Label = styled.label({
  cursor: "pointer",
  display: "flex",
  userSelect: "none"
});
var Input = styled.input(visuallyHiddenStyle);
var CheckboxControl = styled(Box)(css({
  borderRadius: "6px",
  width: "24px",
  height: "24px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));
var Checkbox = React__default.forwardRef(function (_a, ref) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  var checked = rest.checked,
    defaultChecked = rest.defaultChecked,
    onChange = rest.onChange;
  var _b = React__default.useState(defaultChecked || false),
    isChecked = _b[0],
    setChecked = _b[1];
  React__default.useEffect(function () {
    setChecked(checked || defaultChecked || false);
  }, [checked, defaultChecked]);
  var handleChange = React__default.useCallback(function (e) {
    if (checked === undefined) {
      setChecked(e.target.checked);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [checked, onChange]);
  return React__default.createElement(Label, null, React__default.createElement(Input, __assign({}, rest, {
    type: "checkbox",
    onChange: handleChange,
    ref: ref
  })), React__default.createElement(CheckboxControl, {
    isChecked: isChecked
  }, !isChecked ? React__default.createElement(Icon, {
    icon: "checkbox",
    fontSize: "24px",
    color: "grey.5"
  }) : React__default.createElement(Icon, {
    icon: "checkbox_fill",
    fontSize: "24px",
    color: "green.300"
  })), children && React__default.createElement(Box, {
    alignSelf: "stretch",
    maxWidth: "calc(100% - 24px)",
    display: "flex",
    alignItems: "center"
  }, React__default.createElement(Paragraph, {
    size: "sm",
    marginLeft: "16px"
  }, children)));
});
export { Checkbox };